import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class LocalStorageRepository {

  constructor() {
    // empty
  }

  saveChosenClientId(clientId: number): void {
    localStorage.setItem('__chosenClientId', clientId.toString());
  }

  getChosenClientId(): number|null {
    const value = localStorage.getItem('__chosenClientId');

    if(value) {
      return Number(value);
    }

    return null;
  }

  saveChosenPlantId(plantId: number) {
    localStorage.setItem('__chosenPlantId', plantId.toString());
  }

  getChosenPlantId(): number|null {
    const value = localStorage.getItem('__chosenPlantId');

    if(value) {
      return Number(value);
    }

    return null;
  }

  saveNavigationPinPreference(pinned: boolean): void {
    localStorage.setItem('__navigationPinPreference', pinned.toString());
  }

  getNavigationPinPreference(): boolean {
    const value = localStorage.getItem('__navigationPinPreference');

    if(value) {
      if(value.toLowerCase() === 'true') {
        return true;
      }
    }

    return false;
  }

  saveSsoEmail(email: string): void {
    localStorage.setItem('__ssoEmail', email);
  }

  getSsoEmail(): string|null {
    return localStorage.getItem('__ssoEmail');
  }

  saveSsoDomain(domain: string): void {
    localStorage.setItem('__ssoDomain', domain);
  }

  getSsoDomain(): string|null {
    return localStorage.getItem('__ssoDomain');
  }

  clearSsoReferences(): void {
    localStorage.removeItem('__ssoEmail');
    localStorage.removeItem('__ssoDomain');
  }

  clearLocalStorage(): void {
    localStorage.removeItem('__chosenClientId');
    localStorage.removeItem('__chosenPlantId');
    localStorage.removeItem('__navigationPinPreference');
    localStorage.removeItem('__ssoEmail');
    localStorage.removeItem('__ssoDomain');
  }
}
